module.exports = __webpack_public_path__ + "r-v3/img/ico_attendance_minus.d3bf44ab.svg";